import { Suspense, lazy } from 'react';


const Dashboard = lazy(() => import('../components/Dashboard/Dashboard'));

const DashboardLazy: React.FC = () => {
    return <Suspense><Dashboard/></Suspense>;
}

export default DashboardLazy;